import React from 'react'
import isObject from 'lodash/isObject'
import {Typography, withStyles} from '@material-ui/core'
import style from './style'
import { OFFLINE_PAYMENT_METHODS } from '../../shared/constants'

export const errorMessages = {
    "Timeout": "El tiempo de operación expiró o excediste la cantidad de intentos de pago. Comunicate con el comercio para que te genere un nuevo link.",
    "Repeated": "Excediste la cantidad de intentos de pago. Comunicate con el comercio para que te genere un nuevo link.",
    "InvalidApikey": "Link inválido.",
    "HashNotFound": "Link inválido.",
    "HashAlreadyExecuted": "Transacción finalizada.",
    "Other": "Verifica los datos ingresados e intenta realizar la operación nuevamente.",
    "OnlinePaymentError": "Verifica los datos ingresados e intenta realizar la operación nuevamente.",
    "OfflinePaymentError": "Se ha producido un error al intentar generar el comprobante. Intenta realizar la operación nuevamente.",
}

const getErrorMessage = (paymentMethod, error) => {

    if(!isObject(error)) return errorMessages[error] || errorMessages["Other"]

    // Retrocompatibilidad con el pago
    if(error.timeout) return errorMessages["Timeout"]

    if(error.message === "repeated") return errorMessages["Repeated"]

    return OFFLINE_PAYMENT_METHODS.indexOf(paymentMethod[0]) >= 0
        ? errorMessages["OfflinePaymentError"]
        : errorMessages["OnlinePaymentError"]
}

/**
 * Renders an error message
 */
const NotSuccessfulPaymentSummary = ({classes, error, resultData}) => {
    const paymentMethods = !!resultData && !!resultData.paymentMethod ? resultData.paymentMethod : []
    const description = getErrorMessage(paymentMethods, error)

    return (
        <div className={classes.main}>
            <Typography variant="body1"
                        id="errorMsg"
                        className={classes.description}>
                {description}
            </Typography>
        </div>
    )
}

export default withStyles(style)(NotSuccessfulPaymentSummary)
